import Vue from 'vue';
import Component from 'vue-class-component';
import dayjs from 'dayjs';
import { DATE_TIME_LONG_FORMAT } from '@/shared/date/filters';
import { Prop, PropSync, Watch } from 'vue-property-decorator';

@Component
export default class CustomDatePicker extends Vue {
  @PropSync('referenceProp') reference: any;
  @Prop() label: string;
  @Prop() minDate: string;
  @Prop() maxDate: string;
  @Prop() activePicker: boolean;
  @Prop() disable: boolean;
  @Prop() icon: string;

  private showMenu = false;
  private activePickerModel = 'false';

  @Watch('showMenu')
  public changeFirstBirthday(newValue) {
    newValue && this.activePicker && setTimeout(() => (this.activePickerModel = 'YEAR'));
  }

  private get formatted() {
    return this.$options.filters.formatJustDateText(this.reference);
  }

  private set formatted(newValue) {
    this.reference = newValue;
  }

  private get datePickerModel() {
    return this.$options.filters.formatJustDate(this.reference);
  }

  private set datePickerModel(newValue) {
    const currentDate = new Date();
    const dateTime = newValue + 'T' + currentDate.getHours().toString() + ':' + currentDate.getMinutes().toString();
    this.reference = dayjs(dateTime, DATE_TIME_LONG_FORMAT).toDate();
  }
}
